require('es6-promise').polyfill()
require('es6-shim')
require('imports?jQuery=jquery!bootstrap')
require('font-awesome-sass-loader')
require('./components/css/style.css')
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './components/App'

import router from './router'
import rootStore from './store'
import focus from 'vue-focus'

// コンポーネント詰め合わせhttp://element.eleme.io/#/en-US
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-default/index.css'

import * as Sentry from '@sentry/browser'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

// 多言語対応
import vuexI18n from 'vuex-i18n'
import i18n from './i18n'

Vue.use(Vuex)

const store = new Vuex.Store(rootStore)
Vue.use(vuexI18n.plugin, store)

Vue.use(ElementUI, {locale})

Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.component('VueSlider', VueSlider)

// 設定可能言語
Vue.i18n.add('ja', i18n.ja)
// 使用言語
Vue.i18n.set('ja')

// 開発ツールを有効化
Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App },
  directives: { focus: focus }
})

Sentry.init({
  dsn: 'https://388f90e4e8914310a35274048237e31d@sentry.io/1409051',
  integrations: [new Sentry.Integrations.Vue({
    Vue,
    attachProps: true
  })],
  environment: process.env.NODE_ENV
})



// WEBPACK FOOTER //
// ./src/main.js